import { Page } from "src/models/api/page/page";
import { DTOModel } from "src/models/base/dto-model";
import { LegalEntityOfficeFilter } from "src/models/company-accounts/legal-entities-office";
import { TnASchedulePerDayPlanningSTO } from "src/models/tna/tna-schedule-per-day-planning/tna-schedule-per-day-planning-sto";
import { BaseApiService } from "../base/base-api.service";

export class TnASchedulePerDayPlanningApiService extends BaseApiService<DTOModel, TnASchedulePerDayPlanningSTO> {
  constructor() {
    super({
      servicePath: "/TnASchedulePerDayPlanning",
      loadItemsPath: "",
      saveItemsPath: "/SaveTnASchedulePerDayPlanning",
    });
  }
}

export const loadTnASchedulesPerDayPlanning = async (legalEntityIds: string[]) => {
  try {
    const response = await new TnASchedulePerDayPlanningApiService().loadItems(
      {
        legalEntityIds,
      } as LegalEntityOfficeFilter,
      "",
      [],
      {
        pageNumber: 0,
        pageSize: 100000,
      } as Page,
      undefined,
      60,
      undefined,
      undefined
    );

    if (!response.error) {
      return response.items;
    }
  } catch (error) {
    console.error("Error loading schedules:", error);
  }
};
